import { TweenMax } from 'gsap';
import { SplitText } from '@/assets/libs/SplitText';

export default function title(el) {

  const split = new SplitText(el, { type: 'chars', charsClass: 'char' });
  TweenMax.set(el, {
    // x: 50,
    rotationX: -80,
    autoAlpha: 0,
    y: 0.6 * 60,
  });

  const size = el.dataset.size;

  const amount = size === 'small' ? 2 : 8;

  TweenMax.staggerTo(split.chars, 0, {
    cycle: { y: i => amount * i },
    scaleY: 2,
    transformOrigin: '0% 0%',
  });

  return el;
}
